import { render, staticRenderFns } from "./organogram.vue?vue&type=template&id=1e295d04"
import script from "./organogram.vue?vue&type=script&lang=js"
export * from "./organogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports